<template>
  <div class="gutter-example">
    <a-row :gutter="16">
      <a-col class="gutter-row" :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="6">
        <div class="gutter-total">
          <img src="/icon/institutionPurple.png" alt="icon" />
          <div class="total">
            <p>总课程方数</p>
            <p>{{institutionCount}}</p>
          </div>
        </div>
      </a-col>
      <a-col class="gutter-row" :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="6">
        <div class="gutter-total">
          <img src="/icon/courseGreen.png" alt="icon" />
          <div class="total">
            <p>总课程数</p>
            <p>{{courseCount}}</p>
          </div>
        </div>
      </a-col>
      <a-col class="gutter-row" :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="6">
        <div class="gutter-total">
          <img src="/icon/schoolBlue.png" alt="icon" />
          <div class="total">
            <p>总学校数</p>
            <p>{{schoolCount}}</p>
          </div>
        </div>
      </a-col>
      <a-col class="gutter-row" :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="6">
        <div class="gutter-total">
          <img src="/icon/studentYellow.png" alt="icon" />
          <div class="total">
            <p>总学生数</p>
            <p>{{studentCount}}</p>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col class="gutter-row" :xs="24" :sm="24" :md="24" :lg="24" :xl="12" :xxl="9">
        <div class="gutter-bar">
          <div>
            <span style="color:#151617;font-size:24px">学生报名量&emsp;</span>
            <a-range-picker
              style="width:250px"
              :placeholder="['开始月份', '结束月份']"
              format="YYYY-MM"
              :value="value1"
              :mode="mode1"
              @panelChange="handlePanelChange1"
              @change="handleChange1"
              :size="'small'"
            />
          </div>
          <v-chart :forceFit="true" :height="734" :data="dataStudentApplyTotal1">
            <v-coord type="rect" direction="LB" />
            <v-tooltip />
            <v-axis data-key="country" :label="{ offset: 12 }" />
            <v-bar position="country*population" />
          </v-chart>
        </div>
      </a-col>
      <a-col class="gutter-row" :xs="24" :sm="24" :md="24" :lg="24" :xl="12" :xxl="9">
        <div class="gutter-bar">
          <div>
            <span style="color:#151617;font-size:24px">学生报名占比&emsp;</span>

            <a-range-picker
              style="width:250px"
              :placeholder="['开始月份', '结束月份']"
              format="YYYY-MM"
              :value="value2"
              :mode="mode2"
              @panelChange="handlePanelChange2"
              @change="handleChange2"
              :size="'small'"
            />
          </div>
          <v-chart
            :forceFit="true"
            :height="734"
            :data="dataStudentApplyTotal2"
            :scale="[{dataKey: 'population',min: 0,formatter: '.0%'}]"
          >
            <v-coord type="rect" direction="LB" />
            <v-tooltip />
            <v-axis data-key="country" :label="{ offset: 12 }" />
            <v-bar position="country*population" />
          </v-chart>
        </div>
      </a-col>

      <a-col class="gutter-row" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="6">
        <div class="gutter-pie">
          <v-chart
            :forceFit="true"
            :height="339"
            :data="dataInstitutionCategory"
            :scale="[{dataKey: 'percent',min: 0,formatter: '.0%'}]"
          >
            <v-tooltip :showTitle="false" data-key="name*percent" />
            <v-axis />
            <v-legend data-key="name" />
            <v-pie
              position="percent"
              color="name"
              :vStyle="{
                stroke: '#fff',
                lineWidth: 1
              }"
              :label="[
                'percent',
                {
                  offset: -40,
                  textStyle: {
                    fill: 'white',
                    rotate: 0,
                    textAlign: 'center',
                    shadowBlur: 2,
                    shadowColor: 'rgba(0, 0, 0, .45)'
                  }
                }
              ]"
            />
            <v-coord type="theta" />
          </v-chart>
        </div>
      </a-col>
      <a-col class="gutter-row" :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="6">
        <div class="gutter-pie">
          <v-chart
            :forceFit="true"
            :height="339"
            :data="dataCourseCategory"
            :scale="[{dataKey: 'percent',min: 0,formatter: '.0%'}]"
          >
            <v-tooltip :showTitle="false" data-key="name*percent" />
            <v-axis />
            <v-legend data-key="name" />
            <v-pie
              position="percent"
              color="name"
              :vStyle="{
                stroke: '#fff',
                lineWidth: 1
              }"
              :label="[
                'percent',
                {
                  offset: -40,
                  textStyle: {
                    fill: 'white',
                    rotate: 0,
                    textAlign: 'center',
                    shadowBlur: 2,
                    shadowColor: 'rgba(0, 0, 0, .45)'
                  }
                }
              ]"
            />
            <v-coord type="theta" />
          </v-chart>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import dashboard from "../../api/dashboard";
const DataSet = require("@antv/data-set");

export default {
  name: "analysis",
  data() {
    return {
      institutionCount: 0,
      courseCount: 0,
      schoolCount: 0,
      studentCount: 0,
      dataStudentApplyTotal1: [],
      dataStudentApplyTotal2: [],
      dataInstitutionCategory: [],
      dataCourseCategory: [],
      mode1: ["month", "month"],
      value1: [],
      mode2: ["month", "month"],
      value2: []
    };
  },
  methods: {
    handleChange1(value) {
      this.value1 = value;
      this.studentApplyTotal1();
    },
    handlePanelChange1(value, mode) {
      this.value1 = value;
      this.mode1 = [
        mode[0] === "date" ? "month" : mode[0],
        mode[1] === "date" ? "month" : mode[1]
      ];
      this.studentApplyTotal1();
    },
    handleChange2(value) {
      this.value2 = value;
      this.studentApplyTotal2();
    },
    handlePanelChange2(value, mode) {
      this.value2 = value;
      this.mode2 = [
        mode[0] === "date" ? "month" : mode[0],
        mode[1] === "date" ? "month" : mode[1]
      ];
      this.studentApplyTotal2();
    },
    showStatistics() {
      dashboard.showStatistics().then(res => {
        console.log("顶部数据：", res.data);
        let data = res.data;
        this.institutionCount = data.institutionCount;
        this.courseCount = data.courseCount;
        this.schoolCount = data.schoolCount;
        this.studentCount = data.studentCount;
        this.studentApplyTotal1();
        this.studentApplyTotal2();
      });
    },
    studentApplyTotal1() {
      let param = {};
      if (this.value1[0]) {
        param = {
          startTime: this.value1[0] ? this.value1[0].toDate() : "",
          endTime: this.value1[1] ? this.value1[1].toDate() : ""
        };
      }
      dashboard.studentApplyTotal(param).then(res => {
        console.log("学生报名量排名", res.data);
        let sourceDataBar = res.data;
        let dvBar = new DataSet.View().source(sourceDataBar);
        dvBar.transform({
          type: "sort",
          callback(a, b) {
            return a.count - b.count > 0;
          }
        });
        let dataStudentApplyTotal = dvBar.rows.map(item => ({
          country: item.name,
          population: item.count * 1
        }));
        this.dataStudentApplyTotal1 = dataStudentApplyTotal;
      });
    },
    studentApplyTotal2() {
      let param = {};
      if (this.value2[0]) {
        param = {
          startTime: this.value2[0] ? this.value2[0].toDate() : "",
          endTime: this.value2[1] ? this.value2[1].toDate() : ""
        };
      }
      dashboard.studentApplyTotal(param).then(res => {
        console.log("学生报名占比", res.data);
        let sourceDataBar = res.data.map(item => ({
          name: item.name,
          count: item.count / this.studentCount
        }));
        let dvBar = new DataSet.View().source(sourceDataBar);
        dvBar.transform({
          type: "sort",
          callback(a, b) {
            return a.count - b.count > 0;
          }
        });
        let dataStudentApplyTotal = dvBar.rows.map(item => ({
          country: item.name,
          population: item.count * 1
        }));
        this.dataStudentApplyTotal2 = dataStudentApplyTotal;
      });
    },
    institutionCategory() {
      dashboard.institutionCategory().then(res => {
        console.log("课程方类别占比", res.data);
        let sourceDataPie = res.data;
        let dvPie = new DataSet.View().source(sourceDataPie);
        dvPie.transform({
          type: "percent",
          field: "count",
          dimension: "name",
          as: "percent"
        });
        this.dataInstitutionCategory = dvPie.rows;
      });
    },
    courseCategory() {
      dashboard.courseCategory().then(res => {
        console.log("课程类别占比", res.data);
        let sourceDataPie = res.data;
        let dvPie = new DataSet.View().source(sourceDataPie);
        dvPie.transform({
          type: "percent",
          field: "count",
          dimension: "name",
          as: "percent"
        });
        this.dataCourseCategory = dvPie.rows;
      });
    }
  },
  created() {
    this.showStatistics();
    this.institutionCategory();
    this.courseCategory();
  }
};
</script>
<style scoped>
.gutter-example {
  padding: 32px;
}

.gutter-total {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  height: 157px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
  margin-bottom: 12px;
}
.gutter-total img {
  flex: 1;
}
.gutter-total .total {
  flex: 5;
}
.total {
  height: 80px;
  padding-left: 12px;
}
.total > p:nth-child(1) {
  font-size: 14px;
  color: #aeb0ba;
}
.total > p:nth-child(2) {
  font-size: 48px;
  color: #151617;
}

.gutter-bar {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  height: 823px;
  padding: 32px;
  margin-bottom: 12px;
}

.gutter-pie {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  height: 405px;
  padding: 32px;
  margin-bottom: 12px;
}
</style>